import React from 'react';
import { oneOfType, bool, array, object } from 'prop-types';

import cx from 'classnames';
import s from './Layout.css';

/**
 * @param className parent override rules, e.g.: adding a background-color
 * @param children the contents of the layout
 * @param centered flex justify-content:center
 * @param column the layout is column flex-direction instead of the default row flex-direection.
 * @param fullscreen the layout is the full visible viewport.
 * @param mobileColumn the layout will switch to a column flex-direction less than 768px in width
 * @param mobileReverse the layout will switch to a flex-direction reverse less than 768px in width
 * @param staticX the layout is not scrollable in the x-direction
 * @param staticY the layout is not scrollable in the y-direction
 */
function Layout({ className, children, centered, column, fullscreen, mobileColumn, mobileReverse, staticX, staticY, }) {
  const columnClass = column ? s.column : '';
  const centeredClass = centered ? s.centered : '';
  const fullscreenClass = fullscreen ? s.fullscreen : '';
  const mobileColumnClass = mobileColumn ? s.mobileColumn : '';
  const mobileReverseClass = mobileReverse ? s.mobileReverse : '';
  const staticClassX = staticX ? s.staticX : '';
  const staticClassY = staticY ? s.staticY : '';

  return (
    <div className={cx(s.component, className, centeredClass, columnClass, fullscreenClass, mobileReverseClass, mobileColumnClass, staticClassX, staticClassY)}>
      {children}
    </div>
  );
}

Layout.propTypes = {
  children: oneOfType([
    array,
    object
  ]),
  column: bool,
  fullscreen: bool,
  mobileColumn: bool,
  mobileReverse: bool,
  staticX: bool,
  staticY: bool,
};

export default Layout;
